import {
  BanknoteX,
  Building,
  Building2,
  Activity,
  CalendarCheck, // Apartment
  Gift,
  Headphones,
  Heart,
  Home,
  HousePlus, // Villa
  LandPlot,
  LockKeyhole,
  Mail, // Commercial Unit
  Map,
  MapPinHouse,
  Phone, // Residential/Commercial Land
  Store,
  UserPen,
  Wallet,
  Warehouse,
  Wrench,
} from "lucide-react";
import {
  FaBehance,
  FaDiscord,
  FaDribbble,
  FaEnvelope,
  FaFacebookF,
  FaGithubAlt,
  FaGitlab,
  FaInstagram,
  FaLinkedinIn,
  FaMediumM,
  FaPhone,
  FaPinterestP,
  FaRedditAlien,
  FaSnapchat,
  FaSoundcloud,
  FaTelegramPlane,
  FaTiktok,
  FaVimeoV,
  FaWhatsapp,
  FaYoutube,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FiDollarSign, FiHome, FiMapPin, FiMaximize2 } from "react-icons/fi";
import { IoLogoInstagram } from "react-icons/io";

import { AiOutlineSpotify } from "react-icons/ai";
import { CiGlobe } from "react-icons/ci";
import { RiTwitterXLine } from "react-icons/ri";
import { TiSocialFlickrCircular } from "react-icons/ti";

export const navLinks = [
  { label: "home", href: "/" },
  { label: "about", href: "/about-us" },
  { label: "properties", href: "/properties" },
  { label: "agent", href: "/agents" },
  { label: "developers", href: "/developers" },
  { label: "realEstateProjects", href: "/real-estate-projects" },
  // { label: "auctions", href: "/auctions" },
  { label: "contact", href: "/contact-us" },
];

export const footerLinks = [
  { label: "home", href: "/" },
  { label: "about", href: "/about-us" },
  { label: "properties", href: "/properties" },
  { label: "banks", href: "/banks" },
  { label: "blog", href: "/blog" },
  // { label: "auctions", href: "/auctions" },
  { label: "terms", href: "/terms", tab: 0 },
  { label: "privacyPolicy", href: "/terms", tab: 1 },
  { label: "intellectualProperty", href: "/terms", tab: 2 },
  { label: "complaintsAndSuggestions", href: "/complaints-and-suggestions" },
  { label: "contact", href: "/contact-us" },
];

export const mainSearchOptions = [
  { icon: FiHome, key: "type", label: "Property Type" },
  { icon: FiMapPin, key: "location", label: "Location" },
  {
    icon: FiDollarSign,
    key: "price",
    label: "Price",
    img: "/Saudi_Riyal_Symbol-1.png",
  },
  { icon: FiMaximize2, key: "area", label: "Area" },
];

export const propertyTypes = [
  {
    id: 1,
    label: { ar: "شقة سكنية", en: "Apartment" },
    value: "apartment",
    icon: Building2,
  },
  {
    id: 2,
    label: { ar: "فيلا", en: "Villa" },
    value: "villa",
    icon: Home,
  },
  {
    id: 3,
    label: { ar: "أرض", en: "Land" },
    value: "land",
    icon: LandPlot,
  },
  {
    id: 4,
    label: { ar: "عقار تجاري", en: "Commercial" },
    value: "commercial",
    icon: Store,
    children: [
      {
        id: 41,
        label: { ar: "مبنى سكني", en: "Residential Building" },
        value: "residential-building",
        icon: Building,
      },
      {
        id: 42,
        label: { ar: "مجمع تجاري", en: "Commercial Complex" },
        value: "commercial-complex",
        icon: Store,
      },
      {
        id: 43,
        label: { ar: "مستودعات", en: "Warehouses" },
        value: "warehouses",
        icon: Warehouse,
      },
      {
        id: 44,
        label: { ar: "إستراحات", en: "Rest Houses" },
        value: "rest-houses",
        icon: HousePlus,
      },
    ],
  },
  {
    id: 8,
    label: { ar: "مزرعة", en: "Farm" },
    value: "farm",
    icon: Map,
  },
];

export const recentlyAddedProperties = [
  {
    id: 1,
    name_en: "Modern House",
    name_ar: "منزل حديث",
    location: "Sale - Jeddah",
    price: 178000000,
    description_en:
      "A beautiful modern house located in the heart of the city.",
    description_ar: "منزل حديث جميل يقع في قلب المدينة.",
    image: "/recently.png",
    isFav: true,
  },
  {
    id: 2,
    name_en: "Modern House",
    name_ar: "منزل حديث",
    location: "Sale - Jeddah",
    price: 178000000,
    description_en:
      "A beautiful modern house located in the heart of the city.",
    description_ar: "منزل حديث جميل يقع في قلب المدينة.",
    image: "/recently.png",
  },
  {
    id: 3,
    name_en: "Modern House",
    name_ar: "منزل حديث",
    location: "Sale - Jeddah",
    price: 178000000,
    description_en:
      "A beautiful modern house located in the heart of the city.",
    description_ar: "منزل حديث جميل يقع في قلب المدينة.",
    image: "/recently.png",
  },
  {
    id: 4,
    name_en: "Modern House",
    name_ar: "منزل حديث",
    location: "Sale - Jeddah",
    price: 178000000,
    description_en:
      "A beautiful modern house located in the heart of the city.",
    description_ar: "منزل حديث جميل يقع في قلب المدينة.",
    image: "/recently.png",
  },
];

export const latestBlogs = [
  {
    id: 1,
    img: "/man-is-holding-key-that-says-toy-house-it.png",
    title_ar: "نصائح للاستثمار في العقارات في السوق الحالي",
    title_en: "Tips for Investing in Real Estate in the Current Market",
    date: "August 20, 2024",
    content_en:
      "Investing in real estate can be a lucrative venture, but it's essential to understand the current market trends and make informed decisions.",
    content_ar:
      "يمكن أن يكون الاستثمار في العقارات مشروعًا مربحًا، ولكن من الضروري فهم اتجاهات السوق الحالية واتخاذ قرارات مستنيرة.",
  },
  {
    id: 2,
    img: "/new-modern-townhouses-palm-trees 1.png",
    title_ar: "أفضل الأحياء للعيش في جدة",
    title_en: "Best Neighborhoods to Live in Jeddah",
    date: "September 5, 2024",
    content_en:
      "Jeddah offers a variety of neighborhoods, each with its unique charm and amenities. Discover the best areas to call home.",
    content_ar:
      "تقدم جدة مجموعة متنوعة من الأحياء، كل منها يتمتع بسحره ووسائله الفريدة. اكتشف أفضل المناطق لتسميتها منزلك.",
  },
];

export const contactInfo = [
  {
    id: 1,
    icon: Phone,
    value: "+966 5306 62244",
    type: "phone",
  },
  {
    id: 2,
    icon: Mail,
    value: "info@sna-alaqaria.com",
    type: "email",
  },
  {
    id: 3,
    icon: MapPinHouse,
    value: "Makkah",
    valueAr: "مكة المكرمة",
    type: "address",
  },
];

export const mainFeatures = [
  {
    id: 1,
    name_en: "Distinctive service",
    name_ar: "خدمة مميزة",
    description_en:
      "We provide exceptional real estate services tailored to your needs.",
    description_ar: "نحن نقدم خدمات عقارية استثنائية مصممة لتلبية احتياجاتك.",
    icon: "/security-lock.png",
  },
  {
    id: 2,
    name_en: "Booking speed",
    name_ar: "سرعة الحجز",
    description_en:
      "Our platform ensures quick and efficient property bookings.",
    description_ar: "تضمن منصتنا حجوزات عقارية سريعة وفعالة.",
    icon: "/checkmark-square-03.png",
  },
  {
    id: 3,
    name_en: "Trusted agents",
    name_ar: "وكلاء موثوقون",
    description_en:
      "Work with experienced agents who prioritize your satisfaction.",
    description_ar: "تعاون مع وكلاء ذوي خبرة يضعون رضاك في المقام الأول.",
    icon: "/city-01.png",
  },
];

export const agentsData = [
  {
    id: 1,
    img: "/Strategic-Learning-mob.webp",
    name: "Abdallah Mohamed",
    slug: "abdallah-mohamed",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    description_en:
      "A highly experienced real estate agent recognized for his ability to understand client needs, analyze market trends, and provide tailored solutions. Abdallah combines deep market knowledge with exceptional communication skills, ensuring every client enjoys a smooth and successful property-buying experience. Known for his professionalism and commitment, he guides families and investors toward the right decisions with confidence.",
    description_ar:
      "وكيل عقارات ذو خبرة واسعة يتميز بقدرته على فهم احتياجات العملاء وتحليل اتجاهات السوق وتقديم حلول عقارية مُصممة خصيصًا لهم. يجمع عبد الله بين المعرفة العميقة بالسوق ومهارات التواصل الفعّالة، مما يضمن تجربة سلسة وناجحة لكل عميل. معروف باحترافيته والتزامه، ويقود العائلات والمستثمرين نحو القرار الصحيح بثقة.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
  {
    id: 2,
    img: "/Strategic-Learning-mob.webp",
    name: "Mohamed Ahmed",
    slug: "mohamed-ahmed",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    description_en:
      "A professional commercial-property specialist who helps businesses identify strategic, high-value locations for long-term growth. Mohamed expertly evaluates market opportunities, negotiates competitive deals, and supports companies in securing properties that align with their operational and financial goals. His strategic mindset and analytical skills make him a trusted advisor in the commercial real estate sector.",
    description_ar:
      "وكيل محترف متخصص في العقارات التجارية، يساعد الشركات على اختيار مواقع استراتيجية عالية القيمة لدعم نموها على المدى الطويل. يمتلك محمد خبرة واسعة في تحليل الفرص السوقية والتفاوض على أفضل الصفقات ودعم الشركات في الحصول على العقار المناسب لأهدافها التشغيلية والمالية. بفضل فكره الاستراتيجي ومهاراته التحليلية، يُعد مستشارًا موثوقًا في سوق العقارات التجارية.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
  {
    id: 3,
    img: "/Strategic-Learning-mob.webp",
    name: "Omar Khaled",
    slug: "omar-khaled",
    description_en:
      "A professional commercial-property specialist who helps businesses identify strategic, high-value locations for long-term growth. Mohamed expertly evaluates market opportunities, negotiates competitive deals, and supports companies in securing properties that align with their operational and financial goals. His strategic mindset and analytical skills make him a trusted advisor in the commercial real estate sector.",
    description_ar:
      "وكيل محترف متخصص في العقارات التجارية، يساعد الشركات على اختيار مواقع استراتيجية عالية القيمة لدعم نموها على المدى الطويل. يمتلك محمد خبرة واسعة في تحليل الفرص السوقية والتفاوض على أفضل الصفقات ودعم الشركات في الحصول على العقار المناسب لأهدافها التشغيلية والمالية. بفضل فكره الاستراتيجي ومهاراته التحليلية، يُعد مستشارًا موثوقًا في سوق العقارات التجارية.",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
  {
    id: 4,
    img: "/Strategic-Learning-mob.webp",
    name: "Abdallah Ahmed",
    slug: "abdallah-ahmed-2",
    description_en:
      "A professional commercial-property specialist who helps businesses identify strategic, high-value locations for long-term growth. Mohamed expertly evaluates market opportunities, negotiates competitive deals, and supports companies in securing properties that align with their operational and financial goals. His strategic mindset and analytical skills make him a trusted advisor in the commercial real estate sector.",
    description_ar:
      "وكيل محترف متخصص في العقارات التجارية، يساعد الشركات على اختيار مواقع استراتيجية عالية القيمة لدعم نموها على المدى الطويل. يمتلك محمد خبرة واسعة في تحليل الفرص السوقية والتفاوض على أفضل الصفقات ودعم الشركات في الحصول على العقار المناسب لأهدافها التشغيلية والمالية. بفضل فكره الاستراتيجي ومهاراته التحليلية، يُعد مستشارًا موثوقًا في سوق العقارات التجارية.",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
  {
    id: 5,
    img: "/Strategic-Learning-mob.webp",
    name: "Sara Mostafa",
    slug: "sara-mostafa",
    description_en:
      "A professional commercial-property specialist who helps businesses identify strategic, high-value locations for long-term growth. Mohamed expertly evaluates market opportunities, negotiates competitive deals, and supports companies in securing properties that align with their operational and financial goals. His strategic mindset and analytical skills make him a trusted advisor in the commercial real estate sector.",
    description_ar:
      "وكيل محترف متخصص في العقارات التجارية، يساعد الشركات على اختيار مواقع استراتيجية عالية القيمة لدعم نموها على المدى الطويل. يمتلك محمد خبرة واسعة في تحليل الفرص السوقية والتفاوض على أفضل الصفقات ودعم الشركات في الحصول على العقار المناسب لأهدافها التشغيلية والمالية. بفضل فكره الاستراتيجي ومهاراته التحليلية، يُعد مستشارًا موثوقًا في سوق العقارات التجارية.",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
  {
    id: 6,
    img: "/Strategic-Learning-mob.webp",
    name: "Hassan Tarek",
    slug: "hassan-tarek",
    description_en:
      "A professional commercial-property specialist who helps businesses identify strategic, high-value locations for long-term growth. Mohamed expertly evaluates market opportunities, negotiates competitive deals, and supports companies in securing properties that align with their operational and financial goals. His strategic mindset and analytical skills make him a trusted advisor in the commercial real estate sector.",
    description_ar:
      "وكيل محترف متخصص في العقارات التجارية، يساعد الشركات على اختيار مواقع استراتيجية عالية القيمة لدعم نموها على المدى الطويل. يمتلك محمد خبرة واسعة في تحليل الفرص السوقية والتفاوض على أفضل الصفقات ودعم الشركات في الحصول على العقار المناسب لأهدافها التشغيلية والمالية. بفضل فكره الاستراتيجي ومهاراته التحليلية، يُعد مستشارًا موثوقًا في سوق العقارات التجارية.",
    bio_en:
      "Experienced real estate agent with a proven track record in closing deals and helping clients find their dream homes.",
    bio_ar:
      "وكيل عقارات ذو خبرة مع سجل حافل في إتمام الصفقات ومساعدة العملاء في العثور على منازل أحلامهم.",
    phone: "+966 123456789",
    email: "abdallahmohamed@sna.com",
    socials: [
      { icon: FaFacebookF, link: "https://facebook.com" },
      { icon: IoLogoInstagram, link: "https://instagram.com" },
      { icon: FaLinkedinIn, link: "https://linkedin.com" },
      { icon: FaXTwitter, link: "https://x.com" },
    ],
  },
];

export const profileSidebarLinks = [
  {
    id: 1,
    name_en: "Account",
    name_ar: "الحساب",
    href: "/profile",
    icon: UserPen,
  },
  {
    id: 4,
    name_en: "Update Password",
    name_ar: "تحديث كلمة المرور",
    href: "/profile/update-password",
    icon: LockKeyhole,
  },
  {
    id: 2,
    name_en: "Wallet",
    name_ar: "المحفظة",
    href: "/profile/wallet",
    icon: Wallet,
  },
  {
    id: 3,
    name_en: "My Reservations",
    name_ar: "حجوزاتي",
    href: "/profile/reservations",
    icon: CalendarCheck,
  },
  {
    id: 5,
    name_en: "My Financing",
    name_ar: "تمويلاتي",
    href: "/profile/my-financing",
    icon: BanknoteX, // Bank ICON
  },
  {
    id: 6,
    name_en: "Favorites",
    name_ar: "المفضلة",
    href: "/profile/favorites",
    icon: Heart,
  },
  {
    id: 10,
    name_en: "My Rewards",
    name_ar: "مكافآتي",
    href: "/profile/rewards",
    icon: Gift,
  },
  {
    id: 7,
    name_en: "Market Monitor",
    name_ar: "مراقب السوق",
    href: "/profile/market-monitor",
    icon: Activity,
  },
  {
    id: 9,
    name_en: "My Service Requests",
    name_ar: "طلبات خدماتي",
    href: "/profile/service-requests",
    icon: Wrench,
  },
  {
    id: 8,
    name_en: "Live Support",
    name_ar: "الدعم المباشر",
    href: "/profile/support",
    icon: Headphones,
  },
];

// ───────── REGIONS ─────────
export const regions = [
  { value: "riyadh", label_ar: "الرياض", label_en: "Riyadh" },
  { value: "makkah", label_ar: "مكة المكرمة", label_en: "Makkah" },
  {
    value: "madinah",
    label_ar: "المدينة المنورة",
    label_en: "Madinah",
  },
  { value: "qassim", label_ar: "القصيم", label_en: "Qassim" },
  {
    value: "eastern_province",
    label_ar: "المنطقة الشرقية",
    label_en: "Eastern Province",
  },
  { value: "asir", label_ar: "عسير", label_en: "Asir" },
  { value: "tabuk", label_ar: "تبوك", label_en: "Tabuk" },
  { value: "hail", label_ar: "حائل", label_en: "Hail" },
  {
    value: "northern_borders",
    label_ar: "الحدود الشمالية",
    label_en: "Northern Borders",
  },
  { value: "jazan", label_ar: "جازان", label_en: "Jazan" },
  { value: "najran", label_ar: "نجران", label_en: "Najran" },
  { value: "al_bahah", label_ar: "الباحة", label_en: "Al Bahah" },
  { value: "al_jouf", label_ar: "الجوف", label_en: "Al Jouf" },
];

// ───────── PROPERTY TYPES ─────────
export const properties = [
  { value: "apartment", label_ar: "شقة", label_en: "Apartment" },
  { value: "villa", label_ar: "فيلا", label_en: "Villa" },
  { value: "chalet", label_ar: "شاليه", label_en: "Chalet" },
  { value: "commercial", label_ar: "تجاري", label_en: "Commercial" },
  { value: "land", label_ar: "أرض", label_en: "Land" },
  { value: "office", label_ar: "مكتب", label_en: "Office" },
  { value: "shop", label_ar: "محل", label_en: "Shop" },
  { value: "warehouse", label_ar: "مستودع", label_en: "Warehouse" },
  { value: "house", label_ar: "منزل", label_en: "House" },
  { value: "studio", label_ar: "استوديو", label_en: "Studio" },

  // NEW
  { value: "duplex", label_ar: "دوبلكس", label_en: "Duplex" },
  { value: "penthouse", label_ar: "بنتهاوس", label_en: "Penthouse" },
  { value: "farm", label_ar: "مزرعة", label_en: "Farm" },
  { value: "camp", label_ar: "مخيم", label_en: "Camp" },
  { value: "floor", label_ar: "دور", label_en: "Floor" },
  { value: "building", label_ar: "عمارة", label_en: "Building" },
  { value: "room", label_ar: "غرفة", label_en: "Room" },
  {
    value: "residential_land",
    label_ar: "أرض سكنية",
    label_en: "Residential Land",
  },
  {
    value: "commercial_land",
    label_ar: "أرض تجارية",
    label_en: "Commercial Land",
  },
  { value: "showroom", label_ar: "معرض", label_en: "Showroom" },
  {
    value: "hotel_apartment",
    label_ar: "شقة فندقية",
    label_en: "Hotel Apartment",
  },
  { value: "rest_house", label_ar: "استراحة", label_en: "Rest House" },
];

export const socialMediaPlatforms = [
  { label: "Facebook", value: "facebook", icon: FaFacebookF },
  { label: "Twitter X", value: "twitter", icon: RiTwitterXLine },
  { label: "Instagram", value: "instagram", icon: FaInstagram },
  { label: "Phone", value: "phone", icon: FaPhone },
  { label: "Email", value: "email", icon: FaEnvelope },
  { label: "WhatsApp", value: "whatsapp", icon: FaWhatsapp },
  { label: "LinkedIn", value: "linkedin", icon: FaLinkedinIn },
  { label: "Snapchat", value: "snapchat", icon: FaSnapchat },
  { label: "TikTok", value: "tiktok", icon: FaTiktok },
  { label: "YouTube", value: "youtube", icon: FaYoutube },
  { label: "Telegram", value: "telegram", icon: FaTelegramPlane },
  { label: "Pinterest", value: "pinterest", icon: FaPinterestP },
  { label: "Reddit", value: "reddit", icon: FaRedditAlien },
  { label: "Discord", value: "discord", icon: FaDiscord },
  { label: "GitHub", value: "github", icon: FaGithubAlt },
  { label: "GitLab", value: "gitlab", icon: FaGitlab },
  { label: "Dribbble", value: "dribbble", icon: FaDribbble },
  { label: "Behance", value: "behance", icon: FaBehance },
  { label: "Vimeo", value: "vimeo", icon: FaVimeoV },
  { label: "Flickr", value: "flickr", icon: TiSocialFlickrCircular },
  { label: "Medium", value: "medium", icon: FaMediumM },
  { label: "SoundCloud", value: "soundcloud", icon: FaSoundcloud },
  { label: "Spotify", value: "spotify", icon: AiOutlineSpotify },
  { label: "Website", value: "website", icon: CiGlobe },
];

export const statusConfig: any = {
  active: {
    ar: "متاحة للبيع",
    en: "Available for Sale",
    color: "text-emerald-600 bg-emerald-50 ring-emerald-100",
  },
  available: {
    ar: "متاحة للبيع",
    en: "Available for Sale",
    color: "text-emerald-600 bg-emerald-50 ring-emerald-100",
  },
  inactive: {
    ar: "غير متاحة",
    en: "Not Available",
    color: "text-rose-600 bg-rose-50 ring-rose-100",
  },
  completed: {
    ar: "تم البيع",
    en: "Sold Out",
    color: "text-blue-600 bg-blue-50 ring-blue-100",
  },
};
